/*!
 *
 * header-fixed.js
 *
 */

var def = {
	target: $('.st-Header'),
	showClass: 'is-show'
};

var build = function(elem, opt){
	var $clone = $(elem).clone(true).addClass('clone-Header').appendTo('body');

	$clone.find('#global').attr('id', 'cloneGlobal');
	$clone.find('#menu').children('a').attr('href', '#cloneGlobal');
	$clone.find('#menu').attr('id', '#cloneMenu');
	
	var getSize = function(){
		return opt.target.offset().top + opt.target.outerHeight();
	};

	var top = getSize();

	origin.$window.on('scroll', function(){
		var scrollTop = $(this).scrollTop();
		if( top < scrollTop ){
			$clone.addClass(opt.showClass);
		}else {
			$clone.removeClass(opt.showClass);
		};
	});
};


 $.fn.headerFixed = function(options){
 	return this.each(function(){
 		var opt = $.extend({}, def, options);
 		build(this, opt);
 	});
 };


//////////////////
// WEBPACK FOOTER
// ./dev/js/module/header-fixed.js
// module id = 18
// module chunks = 0